import { render, staticRenderFns } from "./Changepwd.vue?vue&type=template&id=2ad2a964&scoped=true"
import script from "./Changepwd.vue?vue&type=script&lang=js"
export * from "./Changepwd.vue?vue&type=script&lang=js"
import style0 from "./Changepwd.vue?vue&type=style&index=0&id=2ad2a964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2a964",
  null
  
)

export default component.exports